import axios from "axios";
import { urlApiAsesoria } from "../Config/baseUrl";
import { IListarPreguntasAPI } from "../Interfaces/IPreguntasFrecuentes";


const config = {
  headers: {
    'Content-Type': 'application/json',
  }
}


export const listarPreguntas = ( data: IListarPreguntasAPI ) => {
  return axios.post(urlApiAsesoria + 'fit4/listarPreguntasFrecuentes', data, config)
} 